import {memo} from 'react'
import utils from '@eitje/utils'
import {requireProps} from '../../../../helpers'
import {Layout} from '../../../layout'
import {Dropdown} from '../../../dropdown'
import {BasicTableCell} from '../cell'
import {useBasicTableContext} from '../../context'
import './index.less'

export const BasicTableRow = memo(({item, columns, index}) => {
	const context = useBasicTableContext()
	const props = {...context, item, columns}
	const {tooltip, textRows, layoutProps, rowTo, rowModalLink, RowDropdownItemsFn, RowDropdownItems} = context
	const {message, typeId, rowType} = item
	const customRow = !!typeId

	const _tooltip = utils.funcOrVal(tooltip, props)
	const _layoutProps = utils.funcOrVal(layoutProps, props) || {}
	const title = _tooltip || utils.funcOrVal(message, props)
	const sharedProps = {
		minHeight: 40,
		className: utils.makeCns(utils.makeCnVariants('basic-table-row', customRow && 'custom'), rowType),
		width: 'full',
		gap: 0,
		tooltip: title,
		..._layoutProps,
	}

	if (customRow) {
		const Component = textRows.find(r => r.id == typeId)?.Component
		requireProps('BasicTableRow', {Component})

		return (
			<Layout background="white" {...sharedProps} vertical="stretch">
				<Component {...props} />
			</Layout>
		)
	}

	const to = rowTo && rowTo(item)
	const modalLink = rowModalLink && rowModalLink(item)

	const content = (
		<Layout colorSet {...sharedProps} to={to} modalLink={modalLink}>
			{columns.map(column => (
				<BasicTableCell key={column.id} column={column} item={item} itemIndex={index} />
			))}
		</Layout>
	)

	if (RowDropdownItemsFn) {
		// very ugly, maybe we should change this so consumers always have to pass a fn
		// ideally, we'd accept both under the same prop, but there's no sane way of recognizing if a function is a component or a "plain" function
		const Items = RowDropdownItemsFn(item)

		if (!Items) return content

		return (
			<Dropdown trigger={content} openAtCursorPosition="x">
				<Items item={item} index={index} />
			</Dropdown>
		)
	}

	if (RowDropdownItems) {
		return (
			<Dropdown trigger={content} openAtCursorPosition="x">
				<RowDropdownItems item={item} index={index} />
			</Dropdown>
		)
	}

	return content
})
